import { useNavigate } from "react-router-dom";
import { useUIStore } from "@app/store";

/**
 * 401 Unauthorized Error Page
 *
 * Displays when the user is not authenticated or lacks proper credentials
 */
export function UnauthorizedPage() {
  const navigate = useNavigate();
  const { clearError, error } = useUIStore();

  const handleGoHome = () => {
    clearError();
    navigate("/home");
  };

  const handleGoBack = () => {
    clearError();
    navigate(-1);
  };

  const handleLogin = () => {
    clearError();
    navigate("/auth/login");
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4">
      <div className="max-w-md w-full text-center">
        <h1 className="text-4xl font-bold mb-4">401</h1>
        <p className="text-lg mb-2">Unauthorized</p>
        <p className="text-sm text-muted-foreground mb-6">
          {error?.message ||
            "You need to be authenticated to access this resource."}
        </p>
        <div className="flex gap-4 justify-center">
          <button
            onClick={handleGoBack}
            className="px-6 py-2 bg-secondary text-secondary-foreground rounded-md hover:bg-secondary/90 transition-colors"
          >
            Go Back
          </button>
          <button
            onClick={handleLogin}
            className="px-6 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors"
          >
            Login
          </button>
          <button
            onClick={handleGoHome}
            className="px-6 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors"
          >
            Go Home
          </button>
        </div>
      </div>
    </div>
  );
}
